export default __webpack_public_path__ + "static/media/empWorkService.90d63ed3.svg";